
import { API, graphqlOperation } from 'aws-amplify'
import { createVehicle, updateVehicle, deleteVehicle, createCustomInspection, updateCustomInspection, deleteCustomInspection } from '../../graphql/mutations'

export async function createNewVehicle(uId, vehicleData) {
    return new Promise(
        (resolve, reject) => {
            const vehicleDetails = {
                uId: uId,
                data: JSON.stringify(vehicleData)
            };

            API.graphql(graphqlOperation(createVehicle, {input: vehicleDetails}))
            .then(data => {
                resolve(data)
            })
            .catch(err => {
                console.log(err)
                reject(err)
            })
        }
    )
}

export async function editVehicle(vId, vehicleData) {
    return new Promise(
        (resolve, reject) => {
            const vehicleDetails = {
                id: vId,
                data: JSON.stringify(vehicleData)
            };

            API.graphql(graphqlOperation(updateVehicle, {input: vehicleDetails}))
            .then(data => {
                resolve(data)
            })
            .catch(err => {
                console.log(err)
                reject(err)
            })
        }
    )
}

export async function deleteCurrentVehicle(vId) {
    const confirm = window.confirm("Delete this vehicle?")

    if (confirm) {
        return new Promise(
            (resolve, reject) => {
                const vehicleDetails = {
                    id: vId,
                };
    
                API.graphql(graphqlOperation(deleteVehicle, {input: vehicleDetails}))
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    console.log(err)
                    reject(err)
                })
            }
        )
    } else {
        return 0
    }
}

export async function createNewType(uId, inspectionDetails) {
    return new Promise(
        (resolve, reject) => {
            const inspectionData = {
                uId: uId,
                fallback: inspectionDetails.fallback,
                type: inspectionDetails.name,
                items: JSON.stringify(inspectionDetails.items)
            };

            API.graphql(graphqlOperation(createCustomInspection, {input: inspectionData}))
            .then(data => {
                resolve(data)
            })
            .catch(err => {
                console.log(err)
                reject(err)
            })
        }
    )
}

export async function editType(iId, inspectionDetails) {
    return new Promise(
        (resolve, reject) => {
            const inspectionData = {
                id: iId,
                fallback: inspectionDetails.fallback,
                type: inspectionDetails.name,
                items: JSON.stringify(inspectionDetails.items)
            };

            API.graphql(graphqlOperation(updateCustomInspection, {input: inspectionData}))
            .then(data => {
                resolve(data)
            })
            .catch(err => {
                console.log(err)
                reject(err)
            })
        }
    )
}

export async function deleteSelectedType(iId) {
    const confirm = window.confirm("Delete this Custom Inspection?")

    if (confirm) {
        return new Promise(
            (resolve, reject) => {
                const inspectionDetails = {
                    id: iId,
                };
    
                API.graphql(graphqlOperation(deleteCustomInspection, {input: inspectionDetails}))
                .then(data => {
                    resolve(data)
                })
                .catch(err => {
                    console.log(err)
                    reject(err)
                })
            }
        )
    } else {
        return 0
    }
}

